import { render, staticRenderFns } from "./SurveyAnswersOverview.vue?vue&type=template&id=bbb5132c&"
import script from "./SurveyAnswersOverview.vue?vue&type=script&lang=js&"
export * from "./SurveyAnswersOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb5132c')) {
      api.createRecord('bbb5132c', component.options)
    } else {
      api.reload('bbb5132c', component.options)
    }
    module.hot.accept("./SurveyAnswersOverview.vue?vue&type=template&id=bbb5132c&", function () {
      api.rerender('bbb5132c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/SurveyAnswersOverview.vue"
export default component.exports